import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { ActiveCatalogHeader } from './_layout/-components';
export const Route = createFileRoute('/_staff/device-catalog/active/$id/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  return <VStack className="gap-0">
      <ActiveCatalogHeader />
      <Outlet />
    </VStack>;
}